/******************* 
@purpose : Used for validation schema's 
******************/
import * as Yup from "yup";
import { emailRegex } from "./function";


export const loginSchema = Yup.object({
    email: Yup.string()
        .matches(emailRegex, "Invalid email address")
        .required("Email is required"),
    password: Yup.string().required("Password is required"),
});
